export default __webpack_public_path__ + "static/media/rote_raketa_portrait.bc544cff.jpg";